module.exports = __webpack_public_path__ + "img/crop.04c87504.png";